import { useEffect, useRef } from 'react';
import { usePostHog } from '@posthog/react';
import { useAuth } from './auth-context';

/** Links PostHog events to the logged-in user; resets identity on logout. */
export function PostHogIdentify() {
  const posthog = usePostHog();
  const { user, isLoading } = useAuth();
  const previousUserId = useRef<string | null>(null);

  useEffect(() => {
    if (isLoading || !posthog) {
      return;
    }

    if (user) {
      posthog.identify(user.id, {
        email: user.email,
        role: user.role,
        enterprise_id: user.enterprise_id,
        department: user.department,
      });
      previousUserId.current = user.id;
      return;
    }

    if (previousUserId.current) {
      posthog.reset();
      previousUserId.current = null;
    }
  }, [isLoading, user, posthog]);

  return null;
}
